//sizeChartDetail----start1
  // 创建元素并插入到dom
  function createDom({data,dom,isShowSizeChart,wrapMarginLeft}){
    data.shift();
    if(dom.find(".sizeChartDetailWrap").length){
    	dom.find(".sizeChartDetailWrap").remove();    
    }
    
    if(data.length){
    var ul = $('<ul id="sizeBlock" style="font-size: 12px;width: 100%;background: #fafafa;display: flex;flex-wrap: wrap;margin-left:0px;opacity:1;zoom:0.8"></ul>')
    $.each(data,function(ind,item){
      var li = $(`<li style="border:none;margin: 6px 8px;opacity:1;height: 20px;"><span class='key' style="display: inline-block;color:#000;font-size:9px;font-weight:600">${item.key}</span> : <span class='value'  style="display: inline-block;">${item.value}</span></li>`)
      ul.append(li)
    });
    
    var sizeChartDetailWrap = $(`<div class="sizeChartDetailWrap" style="width: 100%;background: #fafafa;"></div>`)
    var sizeChartSecondEntrance = `
		<div class="sizeChartSecondEntrance" style="display: flex;align-items: center;justify-content: flex-start;font-size: 12px;color: #212121;padding: 10px 0 10px 9px;cursor: pointer;">
			<span style="margin-right:5px">View more size information</span>
			<svg t="1615540207548" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1980" width="10" height="12" fill="#FAFAFA"><path d="M312.49 96.36c8.19 0 16.38 3.12 22.63 9.37L734.14 504.75c12.5 12.5 12.5 32.76 0 45.26L335.12 949.02c-12.5 12.5-32.76 12.5-45.26 0s-12.5-32.76 0-45.25L666.25 527.38l-376.39-376.39c-12.5-12.5-12.5-32.76 0-45.25 6.25-6.26 14.44-9.38 22.63-9.38z" fill="#1D1E1F" p-id="1981"></path></svg>
		</div>
	`
    sizeChartDetailWrap.append(ul)
    if(isShowSizeChart){
    	sizeChartDetailWrap.append(sizeChartSecondEntrance)
    }
    dom.append(sizeChartDetailWrap)
    
    if(wrapMarginLeft){
      dom.find(".sizeChartDetailWrap").css({'margin-left':wrapMarginLeft})
    }
    
    var requestShopifyId = $("#section-product").attr("data-id");
    $(".sizeChartSecondEntrance").on('click',function(e){
      e.preventDefault();
      //点击sizeChart埋点
      typeof ga !== "undefined" && ga('send', 'event',  'sizeChartClick',"click", { shopify_spu_id: requestShopifyId,type:"2" })
      typeof sensors !== "undefined" && sensors.track('sizeChartClick', { shopify_spu_id: requestShopifyId,type:"2" });
      $("#sizeChart_pop_wrap").removeClass('sizeChartNone')
      $("#sizeChart_dom_wrap").removeClass('sizeChartNone')
      $('body').addClass('pageDisableScrolling')
      // 点击x关闭弹层
      $('#sizeChart-close').click(function() {
        $("#sizeChart_pop_wrap").addClass('sizeChartNone')
        $("#sizeChart_dom_wrap").addClass('sizeChartNone')
        $('body').removeClass('pageDisableScrolling')
      })
      //点击蒙层关闭弹层
      $('#sizeChart_pop_wrap').on('click',function(){
        $("#sizeChart_pop_wrap").addClass('sizeChartNone')
        $("#sizeChart_dom_wrap").addClass('sizeChartNone')
        $('body').removeClass('pageDisableScrolling')
      })
    })
    }
  }
  //尺寸模块点击
  window.SizeBlockClick = function SizeBlockClick({sizeItem,dom,id,sizeData,isShowSizeChart,wrapMarginLeft,isShowInseamLengthSize}){
    try{
      if(isShowSizeChart && meta.product.type !== "Gift Cards"){
      	dom.css({"min-height":"70px"});
      }
      var sizeArr=[];
      var requestDamaShopifyId =  id //6850689466534
      var sizeChartDamaUrl = `https://api.thehalara.com/mall-rest/api/v1/sizeChart?shopifySpuId=${requestDamaShopifyId}`
      var sizeChartDamaParameter = ``
      function renderSizeData(data){
        var inchTheadData1 = data.data.data.length? (data.data.data[0].data.columns || []): []
        var inchTheadData2 = data.data.length.length ? (data.data.length[0].data.columns || []):[] 
        var inchTbodyData1 = data.data.data.length? (data.data.data[0].data.tableData || []): []
        var inchTbodyData2 = data.data.length.length ? (data.data.length[0].data.tableData || []) : []
        var inchTheadData = [];
        var inchTbodyData = [];
   
        //body(data) 和 product(length)全展示
//         if(inchTbodyData1.length && inchTbodyData2.length){
//         	for(var j=0;j<inchTbodyData1.length;j++){
//               for(var i =0;i<inchTbodyData2.length;i++){
//                 if(inchTbodyData2[i].item[0].columnName  ===  inchTbodyData1[j].item[0].columnName && inchTbodyData2[i].item[0].columnVal  ===  inchTbodyData1[j].item[0].columnVal ){
//                   for(var k=1;k<inchTbodyData2[i].item.length;k++){
//                     inchTbodyData1[j].item.push(inchTbodyData2[i].item[k])
//                   }
//                 }
//               }
//             }
//             inchTbodyData = inchTbodyData1
//             inchTheadData = inchTheadData1.concat(inchTheadData2.slice(1,inchTheadData2.length))
//         }else if(inchTbodyData1.length && !inchTbodyData2.length){
//         	inchTbodyData = inchTbodyData1
//             inchTheadData = inchTheadData1
//         }else if(!inchTbodyData1.length && inchTbodyData2.length){
//         	inchTbodyData = inchTbodyData2
//             inchTheadData = inchTheadData2
//         }
        
        
        //product字段展示规则：（body展示规则不变）
        //1、所有品类都优先取‘length’，‘tops length’, ‘bottoms length’三个字段的数据，展示规则为只要字段有数据就都展示；
        //2、如果‘length’，‘tops_length’, ‘bottoms_length字段均为空，判断是否有frontLength, backLength，如果有则展示frontLength, backLength字段数据
        
        var newInchTheadData2 = [];
        function isSpecifiedRules({item,name}){
          var itemName;
          if(name === "columnName"){
            itemName = item.columnName &&  item.columnName.toLowerCase()
          }else if(name === "name"){
          	itemName = item.name && item.name.toLowerCase()
          }
          if(itemName){
            if(itemName === "length" || itemName === "tops length" || itemName === "bottoms length"){
                return true
            }else{
              if(itemName === "front length" || itemName === "back length"){
                return true
              }
            }
          }
        }
        
        //裤子内逢长     
        var InseamLengthData = data.data.length.length ? (data.data.length[0].data.tableData || []) : [];
        var InseamLengthSizeData = "";
        if(InseamLengthData.length){
          InseamLengthData.forEach(function(item){
            if(item.item.length && item.item[0].columnVal === sizeItem && item.item[1].columnName && item.item[1].columnName.toLowerCase() === "inseam length"){
              InseamLengthSizeData = item.item[1];
            }
          })
        }
        
        if(inchTbodyData1.length && inchTbodyData2.length){
        	for(var j=0;j<inchTbodyData1.length;j++){
              for(var i =0;i<inchTbodyData2.length;i++){
                if(inchTbodyData2[i].item[0].columnName  ===  inchTbodyData1[j].item[0].columnName && inchTbodyData2[i].item[0].columnVal  ===  inchTbodyData1[j].item[0].columnVal ){
                  for(var k=1;k<inchTbodyData2[i].item.length;k++){
                    
                    if(isSpecifiedRules({item:inchTbodyData2[i].item[k],name:"columnName"})){
                    	inchTbodyData1[j].item.push(inchTbodyData2[i].item[k])
                    }
                  }
                }
              }
            }
            inchTbodyData = inchTbodyData1
            inchTheadData2.slice(1,inchTheadData2.length).forEach(function(item){
            	if(isSpecifiedRules({item:item,name:"name"})){
                   newInchTheadData2.push(item)
                }
            })
            inchTheadData = inchTheadData1.concat(newInchTheadData2)
        }else if(inchTbodyData1.length && !inchTbodyData2.length){
        	inchTbodyData = inchTbodyData1
            inchTheadData = inchTheadData1
        }else if(!inchTbodyData1.length && inchTbodyData2.length){
          	
            for(var i =0;i<inchTbodyData2.length;i++){
              inchTbodyData.push({item:[]})
              for(var k=0;k<inchTbodyData2[i].item.length;k++){
                if(isSpecifiedRules({item:inchTbodyData2[i].item[k],name:"columnName"}) || inchTbodyData2[i].item[k].columnName === "SIZE"){
                  inchTbodyData[i].item.push(inchTbodyData2[i].item[k])
                }
              }
            }
          	inchTheadData.push(inchTheadData2[0])
            inchTheadData2.forEach(function(item){
            	if(isSpecifiedRules({item:item,name:"name"})){
                   inchTheadData.push(item)
                }
            })
        }
        if(!inchTheadData.length){
          	dom.css({"min-height":"unset"});
        	return;
        }
        sizeArr[0]=[]
        for(var j=0;j<inchTheadData.length;j++){
          sizeArr[0].push(inchTheadData[j].name)
        }
        for(var i=0;i<inchTbodyData.length;i++){
          sizeArr[i+1]=[]
          for(var k=0;k<inchTbodyData[i].item.length;k++){
            sizeArr[i+1].push(inchTbodyData[i].item[k].columnVal)
          }
        }
        if(!sizeArr.length) return ;
        var currSelSize={};
        $.each(sizeArr,function(ind,item){
          if(item[0].trim().toLowerCase() ==sizeItem.trim().toLowerCase()){
            currSelSize=item;
            return false
          }
        })
        var inchesArr =[];
        var keys = sizeArr[0];
        $.each(currSelSize,function(ind,item){
          var newItem = item?item:'';
          inchesArr[ind] ={
            key:keys[ind],
            value: keys[ind].toLowerCase().includes('size') ? newItem :newItem +' INCHES'
          };
        })
        createDom({data:inchesArr,dom:dom,isShowSizeChart:isShowSizeChart,wrapMarginLeft:wrapMarginLeft});
        //判断有裤缝长，并且是商品详情
        if(InseamLengthSizeData && isShowInseamLengthSize){
          var sizeChartDetailInseamDom = `<div class="sizeChartDetailInseamLength" style="font-size: 12px;margin: 3px 0 8px 16px;">Inseam Length: ${InseamLengthSizeData.columnVal} INCHES</div>`;
          $(".sizeChartDetailInseamLength").remove();
          $("#ProductSizeChartDetail-Wrap").before(sizeChartDetailInseamDom);
        }
      }
      
      if (sizeData) {
        renderSizeData(sizeData)
      } else {
        if(!requestDamaShopifyId) return;
        //判断上一个id与当前id是否一样，如果一样则不发请求，如果不一样则发请求
        if(window.requestDamaShopifyId && window.requestDamaShopifyData){
          if(Number(window.requestDamaShopifyId) === Number(requestDamaShopifyId)){
          	renderSizeData(window.requestDamaShopifyData)
            return;
          }
        }
        $.ajax({  
          type: "get",  
          url: sizeChartDamaUrl,  
          data: sizeChartDamaParameter, 
          headers:{
            "app-id":"10"
          }
        }).done(function(data){
          if(data.code == 0 && data.data){
            renderSizeData(data);
            window.requestDamaShopifyId = requestDamaShopifyId;
            window.requestDamaShopifyData = data;
          }

        }).fail(function(e){
            $("#ProductSizeChartDetail-Wrap").remove();
        })
      }

    }catch(e){

    }
  }

  //sizeChartDetail----end1